import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import './Contact.css'

import Text from '../components/Text'
import Footer from '../components/Footer'

class Contact extends Component {
  componentWillMount () {
    return this.props.changeHeaderColors('#101110', '#fbdeca')
  }

  render () {
    return (
      <div className='content columns'>
        <div className='sidebar'>
          <div className='sidebarContent' style={{ borderRight: `0.2rem solid #101110` }}>
            <div className='backHome'>
              <Link to='/'>
                <div>
                  <div>
                    Back
                    <svg version='1.1' id='Layer_1' xmlns='http://www.w3.org/2000/svg' xlink='http://www.w3.org/1999/xlink' x='0px' y='0px' width='42.666px' height='15.87px' viewBox='0 0 42.666 15.87' enableBackground='new 0 0 42.666 15.87' space='preserve'>
                      <polygon fill='#101110' points='0,7.935 7.934,0 10.178,0 3.037,7.142 11.869,7.142 42.666,7.142 42.666,8.729 11.869,8.729 3.037,8.729 10.178,15.87 7.934,15.87' />
                    </svg>
                  </div>
                  <div>Home</div>
                </div>
              </Link>
            </div>
          </div>
        </div>
        <div className='column contact'>
          <div className='title'>CONTACT</div>
          <hr />
          <Text>
            <div>
              <a href='mailto:hello@erwancoutellier.com' className='mail'>
                HELLO@ERWAN<br />
                COUTELLIER.COM <img alt='cliparts' src='cliparts/cliparts-02-black.svg' />
              </a>
            </div>
            <div>
              <img alt='cliparts' src='cliparts/cliparts-39.svg' /> +33 (0)6-80-83-23-32
            </div>
          </Text>
          <hr />
          <Text>
            <img alt='cliparts' src='cliparts/cliparts-40.svg' /> DON’T HESITATE TO CONTACT <img alt='cliparts' src='cliparts/cliparts-42.svg' /> ME FOR ANY INQUIRIES!
          </Text>
          <hr />
          <Text>
            <a href='https://www.instagram.com/erwancoutellier/' className='instagram'>INSTAGRAM</a>
          </Text>
          <hr />
          <Footer>
            THE STUDIO IS OPEN FROM<br />
            MONDAY TO FRIDAY<br />
            FROM 10.00 AM TO 7.00 PM
          </Footer>
        </div>
      </div>
    )
  }
}

export default Contact



// WEBPACK FOOTER //
// ./src/pages/Contact.js